import React from 'react';

import {QueryApiIntrospection} from 'query-api/useQueryApiIntrospection';
import SchemaSelector from 'samples/SchemaSelector';

export interface QueryApiSchemaSelectorSchema {
  id: string;
  name: string;
  registryId?: string;
}

export interface QueryApiAllSchemaSelectorProps {
  schemaId: string | null;
  queryApiIntrospection: QueryApiIntrospection;
  handleSchemaChange: (schema: QueryApiSchemaSelectorSchema | null) => void;
  schemaFilter?: (schema: QueryApiSchemaSelectorSchema) => boolean;
  disabled?: boolean;
}

export default function QueryApiAllSchemaSelector({
  schemaId,
  queryApiIntrospection,
  handleSchemaChange,
  schemaFilter,
  disabled = false,
}: QueryApiAllSchemaSelectorProps): JSX.Element {
  return (
    <SchemaSelector
      // Make sure all props are memoized so that TagSchemaSelector (which can be slow to render when
      // there are a lot of schemas) does not rerender unnecessarily.
      error={null}
      isDisabled={disabled}
      onChange={handleSchemaChange}
      selectedSchemaId={schemaId}
      schemas={queryApiIntrospection
        .getAllListableSchemas()
        .filter((schema) => schemaFilter?.(schema) ?? true)}
    />
  );
}
